import { Directive, Renderer, Input, ContentChild, ElementRef } from '@angular/core';
import { FormControlName } from '@angular/forms';

@Directive({
  selector: '[validationStyle]',
  host: {
    '[class.has-danger]': 'hasDanger()'
  }
})
export class ValidationStyleDirective {
  @ContentChild(FormControlName) _formControl: FormControlName;
  private nativeElement: Node;

  constructor(private renderer: Renderer, private element: ElementRef) {
    this.nativeElement = element.nativeElement;
  }

  hasDanger() {
    return this._formControl.invalid && this._formControl.dirty
  }
}


// WEBPACK FOOTER //
// /jenkins/jenkins/workspace/apppronosticos_install_s3_dev/src/app/shared/forms/validation-style.directive.ts